// extracted by mini-css-extract-plugin
export default {"carouselContainer":"ClientesCarousel_carouselContainer__mxFcd","logoSlide":"ClientesCarousel_logoSlide__u-qwq"};